module.exports = __webpack_public_path__ + "media/video1_1.5f9b11bf.mp4";